/**
 * フォーム回答率に応じて進捗バーを表示する
 */

// フォーム項目名一覧
const formItemsMaster = [
  "preferred_date",
  "name",
  "kana",
  "email",
  "address",
  "telephone",
  "question",
  "scheduled_date",
  "participants",
  "original1",
  "original2",
  "original3",
];

/**
 * 日付の必須項目名を追加
 *
 * @param formItems
 * @param requiredItems
 */
const addPreferredDateItems = (formItems, requiredItems) => {
  // 希望日が必須の場合は第一と第二を分けて必須項目に追加
  if (requiredItems.indexOf("preferred_date") >= 0) {
    requiredItems.splice(requiredItems.indexOf("preferred_date"), 1); // preferred_date削除
    requiredItems.push("preferred_date1"); // 第一希望日追加

    if (
      formItems.includes("preferred_date_visible2") &&
      formItems.includes("preferred_date_required2")
    ) {
      // 第二希望日が表示の場合は必須項目に追加
      requiredItems.push("preferred_date2"); // 第二希望日追加
    }
  }

  return requiredItems;
};

/**
 * 必須項目名一覧を取得
 */
const getRequiredItems = () => {
  const formListElement = document.querySelector(".form__list");
  const formItems = formListElement?.dataset.form_list; // サイト別フォーム項目一覧
  let requiredItems = [];
  // 必須項目一覧のみに絞る
  if (formItems !== undefined) {
    requiredItems = formItemsMaster.filter((item) =>
      formItems.includes(`${item}_required`),
    );
  }

  // 日付の必須項目の整理
  requiredItems = addPreferredDateItems(formItems, requiredItems);

  // 住所が必須の場合は郵便番号を必須項目に追加
  if (requiredItems.indexOf("address") >= 0) {
    requiredItems.push("zip");
  }

  // プラポリチェック追加
  requiredItems.push("privacy");

  return requiredItems;
};

/**
 * 第一希望日の入力値チェック
 * 日付・時間・分（フェアの場合は分なし）が入力されているか
 *
 * @param number
 */
const checkPreferredDate = (number) => {
  const dateElement = document.getElementById(`preferred_date${number}`);
  const hourElement = document.getElementById(`reserve_hour${number}`);
  const minuteElement = document.getElementById(`reserve_minute${number}`);
  const timeElement = document.getElementById(`reserve_time${number}`); // フェア時間

  const date = dateElement?.value ?? "";
  const hour = hourElement?.value ?? "";
  const minute = minuteElement?.value ?? "";
  const time = timeElement?.value ?? ""; // フェア時間

  let resultTime = false;
  if (timeElement !== null) {
    // フェア時間が選択されている場合はtrue
    resultTime = time.length > 0;
  } else if (hourElement !== null && minuteElement !== null) {
    // 時間と分がどちらも選択されている場合はtrue
    resultTime = hour.length > 0 && minute.length > 0;
  }

  return (date?.length ?? 0) > 0 && resultTime;
};

/**
 * テキスト項目の入力値チェック
 * 1文字以上入力されているか
 *
 * @param formType 対象項目
 */
const checkTextItem = (formType) => {
  const text =
    document.querySelector(`.js-form_check[name="${formType}"]`)?.value ?? "";

  return (text?.length ?? 0) > 0;
};

/**
 * ご婚礼予定月の入力値チェック
 * 年月どちらも入力されているか
 */
const checkMarriageSchedule = () => {
  const yearElement = document.querySelector(
    '.form__select[name="marriage_year"]',
  );
  const monthElement = document.querySelector(
    '.form__select[name="marriage_month"]',
  );

  const year = yearElement?.value ?? "";
  const month = monthElement?.value ?? "";

  // 年で未定を選択した場合に月の選択は不要
  if (Number.isNaN(Number(year))) {
    return year.length > 0;
  }

  return year.length > 0 && month.length > 0;
};

/**
 * プライバシーポリシー同意チェックボックスのチェック
 *
 * @returns {*}
 */
const checkPrivacyCheck = () => {
  const privacyCheckElement = document.getElementById("privacy_check");

  // プライバシーポリシー同意チェック要素がない場合
  if (!privacyCheckElement) {
    return true; // チェック判定しない
  }

  return privacyCheckElement.checked;
};

/**
 * アイテムごとに入力値チェックをして結果を返却
 *
 * @param formType チェック対象項目
 * @param answeredItems 項目名とチェック結果のセット {formType: bool, formType: bool, ...}
 */
const checkFormItems = (formType, answeredItems) => {
  const newAnsweredItems = { ...answeredItems };

  switch (formType) {
    case "preferred_date1":
      newAnsweredItems[formType] = checkPreferredDate("1");
      break;
    case "preferred_date2":
      newAnsweredItems[formType] = checkPreferredDate("2");
      break;
    case "name":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "kana":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "email":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "zip":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "address":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "telephone":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "question":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "scheduled_date":
      newAnsweredItems[formType] = checkMarriageSchedule();
      break;
    case "participants":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "original1":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "original2":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "original3":
      newAnsweredItems[formType] = checkTextItem(formType);
      break;
    case "privacy":
      newAnsweredItems[formType] = checkPrivacyCheck();
      break;
    default:
      break;
  }

  return newAnsweredItems;
};

const requiredItems = getRequiredItems(); // 必須項目名一覧
const requiredItemNum = requiredItems.length; // 必須項目数
let answeredItems = {}; // 回答済み必須項目

/**
 * フォーム回答進捗表示
 *
 * @param currentAnsweredItems 回答郡 {formType: bool, formType: bool, ...}
 */
const confirmProgress = (currentAnsweredItems) => {
  // 必須項目がない場合は何もしない
  if (+requiredItemNum === 0) {
    return false;
  }
  let answeredItemNum = 0; // 回答済み項目数
  if (Object.keys(currentAnsweredItems).length > 0) {
    // 項目別の回答結果を確認
    Object.keys(currentAnsweredItems).forEach((key) => {
      if (currentAnsweredItems[key]) {
        // 回答結果がtrueの場合は回答済みに1足す
        answeredItemNum += 1;
      }
    });
  }

  const percentage = (answeredItemNum / requiredItemNum) * 100;

  // 回答済み項目数の表示更新
  const answeredElement = document.querySelector(".js-form-progress__answered");
  if (answeredElement) {
    answeredElement.textContent = answeredItemNum;
  }

  // 必須項目数の表示更新
  const requiredElement = document.querySelector(".js-form-progress__required");
  if (requiredElement) {
    requiredElement.textContent = requiredItemNum;
  }

  // 進捗バーの幅更新
  const progressBarElement = document.querySelector(
    ".js-form-progress__bar--now",
  );
  if (progressBarElement) {
    progressBarElement.style.width = `${percentage}%`;
  }

  // 回答率が100%になった場合
  if (+percentage === 100) {
    // 確認画面へのボタンを有効にします
    const buttonElement = document.querySelector(".js-form-progress__button");
    if (buttonElement) {
      buttonElement.classList.remove("is-disabled");
    }

    setTimeout(() => {
      const checkElement = document.querySelector(".js-form-progress__check");
      if (checkElement) {
        checkElement.style.display = "block"; // 最後にチェックマーク表示
      }
    }, 950);
  } else {
    const buttonElement = document.querySelector(".js-form-progress__button");
    if (buttonElement) {
      buttonElement.classList.add("is-disabled");
    }

    const checkElement = document.querySelector(".js-form-progress__check");
    if (checkElement) {
      checkElement.style.display = "none";
    }
  }

  return true;
};

/**
 * 進捗バーの初期表示
 */
const initProgress = () => {
  // 必須項目の入力値チェック
  requiredItems.forEach((value) => {
    answeredItems = checkFormItems(value, answeredItems);
  });

  // 進捗バー表示
  confirmProgress(answeredItems);
};

document.addEventListener("DOMContentLoaded", () => {
  // 初期表示
  initProgress();

  // 固定フッターの確認画面への遷移ボタン（未回答の必須項目がある場合は押せないように）
  document
    .querySelector(".js-form-progress__button")
    // eslint-disable-next-line consistent-return
    ?.addEventListener("click", (e) => {
      if (e.currentTarget.classList.contains("is-disabled")) {
        e.preventDefault(); // デフォルト動作を防ぐ
        return false;
      }
    });

  // フォーム内容変更（1文字ずつ変更を検知）
  document.querySelectorAll(".js-form_check").forEach((element) => {
    element.addEventListener("keyup", (e) => {
      // 変更があった項目の取得
      const formType = e.currentTarget.dataset.form_key;
      if (requiredItems.indexOf(formType) >= 0) {
        // 変更があった項目が必須項目の場合はチェックに回す
        answeredItems = checkFormItems(formType, answeredItems);
        // 進捗率の更新
        confirmProgress(answeredItems);
      }
    });
  });

  // フォーム内容更新
  document.querySelectorAll("form .js-form_check").forEach((element) => {
    element.addEventListener("change", (e) => {
      // 変更があった項目の取得
      const formType = e.currentTarget.dataset.form_key;
      if (requiredItems.indexOf(formType) >= 0) {
        // 変更があった項目が必須項目の場合はチェックに回す
        answeredItems = checkFormItems(formType, answeredItems);
        // 進捗率の更新
        confirmProgress(answeredItems);
      }
    });
  });

  // 第一希望日のリセットボタンクリック時の挙動
  document.querySelector(".js-date_cancel1")?.addEventListener("click", () => {
    setTimeout(() => {
      const formType = "preferred_date1";
      if (requiredItems.indexOf(formType) >= 0) {
        // 変更があった項目が必須項目の場合はチェックに回す
        answeredItems = checkFormItems(formType, answeredItems);
        // 進捗率の更新
        confirmProgress(answeredItems);
      }
    }, 0);
  });

  // 第二希望日のリセットボタンクリック時の挙動
  document.querySelector(".js-date_cancel2")?.addEventListener("click", () => {
    setTimeout(() => {
      const formType = "preferred_date2";
      if (requiredItems.indexOf(formType) >= 0) {
        // 変更があった項目が必須項目の場合はチェックに回す
        answeredItems = checkFormItems(formType, answeredItems);
        // 進捗率の更新
        confirmProgress(answeredItems);
      }
    }, 0);
  });

  // プライバシーポリシーチェックの変更
  document.getElementById("privacy_check")?.addEventListener("change", () => {
    if (requiredItems.indexOf("privacy") >= 0) {
      // 変更があった項目が必須項目の場合はチェックに回す
      answeredItems = checkFormItems("privacy", answeredItems);
      // 進捗率の更新
      confirmProgress(answeredItems);
    }
  });
});
